<template>
    <div class="shop-info-wrapper"
        v-loading="isLoading">
        <div class="shop-info">
            <base-block :logoClass="'icondianpulogo'" name="店铺logo" :height="'80px'">
                <el-image 
                    slot="des"
                    fit="cover"
                    style="width: 60px; height: 60px"
                    :src="shopInfo.logo_image_url ? logo : shopDefaultLogo"
                    :preview-src-list="[shopInfo.logo_image_url ? logo : shopDefaultLogo]">
                </el-image>
                <qiniu-upload slot="btn"
                    :useDefault="false"
                    @upload-success="uploadSuccess">
                    <button class="text-btn">
                        修改
                    </button>
                </qiniu-upload>
            </base-block>
            <base-block :logoClass="'icondianpuming'" name="店铺名" :des="shopInfo.shop_name" btnText="修改" @btn-clicked="updateShopName"/>
            <base-block :logoClass="'iconlianxidianhua'" name="联系电话" :des="shopInfo.phone" btnText="修改" @btn-clicked="updatePhone"/>
            <base-block class="renzheng" :logoClass="'icondianpurenzheng'" name="店铺认证" :btnText="getAuthBtnText" @btn-clicked="toAuthenticate(shopInfo.auth_status)">
                <!-- 未认证 -->
                <template v-if="shopInfo.auth_status === -1" slot="des">
                    <!-- 判断是否是直营店铺 -->
                    <template v-if="shopInfo.shop_type === 1 && shopInfo.chain_shop">
                        <span v-if="shopInfo.chain_shop.auth_status === 1">总店已认证</span>
                        <span v-else>总店未认证，请联系总店认证</span>
                    </template>
                    <span v-else class="weirenzheng">未认证</span>
                </template>
                <!-- 认证中 -->
                <template v-if="shopInfo.auth_status === 0" slot="des">
                    <div class="fx-v-center shenheing">
                        <i class="iconfont icontiming"/>
                        <span>审核中</span>
                    </div>
                </template>
                <!-- 认证通过 -->
                <template v-if="shopInfo.auth_status === 1" slot="des">
                    <div class="renzhengpass text-popper" v-textPopper>
                        <span class="enterprise" v-if="shopInfo.auth_type === 0">企业认证</span>
                        <span class="enterprise" v-if="shopInfo.auth_type === 1">个人认证</span>
                        <span class="enterprise" v-if="shopInfo.auth_type === 2">小微商户</span>
                        <span>{{ shopInfo.auth_name }}</span>
                    </div>
                </template>
                <!-- 认证拒绝 -->
                <template v-if="shopInfo.auth_status === 2" slot="des">
                    <span class="has-refuse">已拒绝</span>
                </template>
            </base-block>
            <!-- 在线支付 -->
            <base-block :logoClass="'iconzaixianzhifu'" name="在线支付" :btnText="getPayBtnText" @btn-clicked="payToApply">
                <template>
                    <!-- 连锁直营店 -->
                    <template v-if="shopInfo.shop_type === 1"> 
                        <span slot="des">{{shopInfo.chain_shop.online_payment !== 0 ? '总部已开通' : '总部未开通'}}</span>
                    </template>
                    <!-- 普通店铺或者加盟店 -->
                    <template v-else>
                        <!-- 去店铺认证  shopInfo.online_payment!== 4 兼容建行支付 -->  
                        <template v-if="shopInfo.auth_status !== 1 && shopInfo.online_payment!== 4" slot="des">
                            <span class="weikaitong">未开通</span><span class="weikaitong-next">开通后，收银台可使用条码收款，支持支付宝和微信。</span>
                        </template>
                        <template v-else>
                            <!-- 未开通支付通道 -->
                            <template v-if="shopInfo.online_payment === 0" slot="des">
                                <span class="weikaitong" v-if="shopInfo.pay_channel.length <= 0 ">未开通</span>
                                <template v-if="shopInfo.pay_channel.length > 0 ">
                                    <span>{{ payText() }}</span>
                                </template>
                            </template>
                            <!-- 开通了支付通道 -->
                            <template v-if="shopInfo.online_payment === 1">
                                <span slot="des">{{payTextTip() }}</span>
                                <!-- <div slot='btn'>
                                    <button class="text-btn" @click="toCenter('查看支付通道申请状态')">查看</button>
                                </div> -->
                                <!-- <span class="weikaitong">未开通</span> -->
                            </template>
                            <template v-if="shopInfo.online_payment === 2">
                                <span slot="des">{{payTextTip() }}</span>
                                <!-- <div slot='btn'>
                                    <button class="text-btn" @click="toCenter('查看支付通道申请状态')">查看</button>
                                </div> -->
                                <!-- <span class="weikaitong">未开通</span> -->
                            </template>
                            <template v-if="shopInfo.online_payment === 3">
                                <span slot="des">{{payTextTip() }}</span>
                                <!-- <div slot='btn'>
                                    <button class="text-btn" @click="toCenter('查看支付通道申请状态')">查看</button>
                                </div> -->
                                <!-- <span class="weikaitong">未开通</span> -->
                            </template>
                            <template v-if="shopInfo.online_payment === 4">
                                <span slot="des">{{payTextTip() }}</span>
                                <!-- <div slot='btn'>
                                    <button class="text-btn" @click="toCenter('查看支付通道申请状态')">查看</button>
                                </div> -->
                                <!-- <span class="weikaitong">未开通</span> -->
                            </template>
                        </template>
                    </template>
                </template>
            </base-block>
            <!-- 店铺地址 -->
            <base-block class="set-bottom-line" :class="{'address-wrap': isEditAddress}" :logoClass="'icondizhi'" name="店铺地址" :height="isEditAddress ? 'auto' : '64px'">
                <template v-if="isEditAddress">
                    <div class="edit-address" slot="des">
                        <div class="edit-address-top fx-v-center mb1">
                            <el-cascader
                                v-model="cascaderValue"
                                :checkStrictly="true"
                                :options="options"
                                :props="{ expandTrigger: 'hover' }"
                                @change="cascaderChange"/>
                            <map-choose
                                class="ml1"
                                ref="mapChooseOne"
                                :propAddress="propAddressOne"
                                :searchLocation="cityName"
                                @getAddress="getDetail"/>
                        </div>
                        <div class="edit-address-bottom">
                            <el-input v-model="addressValue" placeholder="详细地址:如道路、门牌号等" maxlength="64" :show-word-limit="true" :disabled="addressValue.length > 64" @blur="handleAddressBlur"/>
                        </div>
                    </div>
                    <el-button class="save-btn" type="primary" size="medium" @click="saveAddress" slot="btn">保存</el-button>
                </template>
                <template v-else>
                    <div class="fx-v-center" slot="des">
                        <map-choose ref="mapChooseTwo"
                            :propAddress="propAddressTwo"
                            :canClick="false"/>
                        <span class="text-popper ml-10" v-textPopper style="min-width: 100px; max-width: 600px">{{ getShopAddress }}</span>
                    </div>
                    <div slot="btn" class="fx-v-center">
                        <button class="text-btn ml1" @click="updateAddress">修改</button>
                    </div>
                </template>
            </base-block>
            <base-block :logoClass="'icondianpuming'" name="店铺简介" btnText="修改" @btn-clicked="updateDes">
                 <template slot="des">
                    <span class="weikaitong" v-if="!shopInfo.description">未填写</span>
                    <span v-else class="des-on">{{ shopInfo.description }}</span>
                </template>
            </base-block>
            <base-block :logoClass="'iconchuangjianren'" name="资质证件" :height="'80px'">
                <el-image 
                    slot="des"
                    fit="cover"
                    style="width: 60px; height: 60px;margin-right: 8px;"
                    :src="shopInfo.bussiness_license_url ? `https://img.senguo.cc/` + shopInfo.bussiness_license_url + imgSuffix : shopDefaultLogo"
                    :preview-src-list="[shopInfo.bussiness_license_url ? `https://img.senguo.cc/` + shopInfo.bussiness_license_url + imgSuffix : shopDefaultLogo]">
                </el-image>
                <el-image 
                    slot="des"
                    fit="cover"
                    style="width: 60px; height: 60px"
                    :src="shopInfo.bussiness_permission_url ? `https://img.senguo.cc/` + shopInfo.bussiness_permission_url + imgSuffix : shopDefaultLogo"
                    :preview-src-list="[shopInfo.bussiness_permission_url ? `https://img.senguo.cc/` + shopInfo.bussiness_permission_url + imgSuffix : shopDefaultLogo]">
                </el-image>
                <template v-if="shopInfo.bussiness_permission_url || shopInfo.bussiness_permission_url">
                    <div slot="btn" style="color:#999;font-size:14px;margin-right:6px">{{shopInfo.show_bussiness ? '在微商城展示' : '不在微商城展示(建议展示)'}}</div>
                    <el-switch slot="btn" @change="updateShowStatus" v-model="shopInfo.show_bussiness" active-color="#009688" inactive-color="#ddd">
                    </el-switch>
                </template>
                 <qiniu-upload slot="btn"
                    :useDefault="false"
                    @upload-success="uploadLicenseSuccess">
                    <button v-if="!shopInfo.bussiness_permission_url" :disabled="shopInfo.auth_status !== 1" class="text-btn">
                        上传营业执照
                    </button>
                </qiniu-upload>
                <qiniu-upload slot="btn"
                    :useDefault="false"
                    @upload-success="uploadPermissionSuccess">
                    <button :disabled="shopInfo.auth_status !== 1" class="text-btn">
                      {{shopInfo.bussiness_permission_url ? '修改' : '上传'}}店铺经营许可证
                    </button>
                </qiniu-upload>
            </base-block>
            <base-block :logoClass="'iconchuangjianren'" name="创建人">
                <div class="wx-info" slot="des" v-if="shopInfo.creator">
                    <user-info :userInfo="shopInfo.creator"
                        :maxWidth="'calc(100% - 50px)'"/>
                    <span class="person-logo">超管</span>
                </div>
            </base-block>
            <base-block :logoClass="'iconchuangjian'" name="创建时间" :des="shopInfo.create_time"/>
            <base-block class="set-top-line" :logoClass="'iconfufeizhongxin'" name="付费中心" :des="'查看店铺付费记录'" :btnText="'立即前往'" @btn-clicked="toPayCenter"/>
            <update-shop-name ref="updateShopName" @refresh-shop-info="getShopInfo"/>
            <update-des ref="updateDes" @refresh-shop-info="getShopInfo"/>
            <update-phone ref="updatePhone" @refresh-shop-info="getShopInfo"/>
            <!-- <update-address ref="updateAddress" @refresh-shop-info="getShopInfo"/> -->
        </div>
        <div class="fx-v-center mt-12">
            <!-- <shop-renew-download :style="{ flex: 1, marginRight: '10px' }" /> -->
            <shop-renew-download :style="{ flex: 1 }" :isDownload="true" />
        </div>
    </div>
</template>

<script lang="tsx">
import BaseBlock from './modules/base_block.vue'
import UpdatePhone from './modules/update_phone.vue'
import UpdateShopName from './modules/update_shop_name.vue'
import UpdateDes from './modules/update_des.vue'
// import UpdateAddress from './modules/update_address.vue'
import QiniuUpload from '@/components/qiniu_upload/qiniu_upload.vue'
import MapChoose from '@/components/map_choose/map_choose.vue'
import ShopRenewDownload from './modules/shop_renew_download.vue'

import { openNewRenew } from '@/components/new_renew/new_renew.tsx'

// default logo
const shopDefaultLogo = require('./images/shop_default.svg')

// data
import { SG_AREA } from '@/assets/ts/citysOptions'

// utils
import { reactive, ref, onBeforeMount, computed, Ref } from '@vue/composition-api'
import { openMessage, openWarning } from '../../../utils/system'
import addressSelectObj from '@/assets/ts/area'
import { getQiniuImgUrl } from '@/assets/ts/qiniu'
import clone from 'lodash/cloneDeep'

// api
import $fetch from '@/api'
import domain from '../../../config/domain'
import { queryString } from '../../../utils'

const CENTER_DOMAIN = process.env.VUE_APP_CENTER_DOMAIN

export default {
    setup: (props, ctx: any) => {
        // loading
        const isLoading = ref(false)
        // 店铺信息
        const shopInfo = ref<any, any>({})
        // 店铺logo
        const logo = ref('')
        // 是否在编辑店铺地址
        const isEditAddress = ref<boolean>(false)
        const bussiness_license_url = ref<string>('')
        const bussiness_permission_url = ref<string>('')
        const description = ref<string>('')
        // map地址 省市区的code和详细地址
        const propAddressOne = ref<any, any>({})
        const propAddressTwo = ref({})
        // cascader value
        const cascaderValue = ref<any[], any[]>([])
        // address value
        const addressValue = ref('')
        const state = ctx.root.$store.state
        const imgSuffix = ref<string>('?watermark/4/text/5qOu5p6cIHNlbmd1by5jYw==/uw/200/uh/200/fill/I0ZGRkZGRg==/fontsize/500/dissolve/40/rotate/-30')

        const downloadHref = computed(() => {
            return domain.cashier + '#/downloadNavigation'
        })

        const getShopAddress = computed(() => {
            if (cascaderValue.value.length > 0) {

                const [provinceCode, cityCode, districtCode] = cascaderValue.value
                return addressSelectObj.initProviceAndCity(provinceCode, cityCode, districtCode).concat(addressValue.value).join(' ')
            } else {
                const {
                    province_code,
                    city_code,
                    district_code,
                    detailed_address
                } = shopInfo.value
                return addressSelectObj.initProviceAndCity(province_code, city_code, district_code).concat(detailed_address).join(' ')
            }
        })

        const cityName = computed(() => {
            if (cascaderValue.value.length > 0) {

                const [provinceCode, cityCode] = cascaderValue.value
                return addressSelectObj.getCityName(provinceCode, cityCode)
            } else {
                const {
                    province_code,
                    city_code
                } = shopInfo.value
                return addressSelectObj.getCityName(province_code, city_code)
            }
        })

        const getPayBtnText = computed(() => {
            if (shopInfo.value.shop_type === 1) {
                if (shopInfo.value.chain_shop.online_payment === 1) {
                    return "总店已开通"
                } else {
                    return ''
                }
            }
            if (shopInfo.value.pay_channel == null) {
                return ''
            }
            // 没有店铺认证  兼容建行支付
            if (shopInfo.value.auth_status !== 1 && shopInfo.value.online_payment !== 4) {
                return '申请开通'
            }
            // 开通了没有选择当前支付通道
            if (shopInfo.value.online_payment === 0) {
                // 没有开通支付通道
                if (shopInfo.value.pay_channel.length === 0) {
                    return '申请开通'
                }
                // 未开通或者已开通但是没有选择为当前的支付通道
                if (shopInfo.value.pay_channel[0].status === -1 || shopInfo.value.pay_channel[0].status === 1) {
                    return '申请开通'
                }
                if (shopInfo.value.pay_channel[0].status === 0 || shopInfo.value.pay_channel[0].status === 2) {
                    return '查看'
                }
            } else {
                // 商米通道申请流程
                if (getCurChannel.value.status === 1 && getCurChannel.value.channel_type === 1) {
                    // return '更换通道'
                    return '查看'
                }
                return '查看'
            }
        })

        const getAuthBtnText = computed(() => {
            if (shopInfo.value.shop_type === 1) { // 连锁直营店
                return ''
            } else {
                return shopInfo.value.auth_status === -1 ? '去认证' : '查看'
            }
        })

        // channel_type 渠道类型 merchant_no 商户号  status 0 1 
        const getCurChannel = computed(() => {
            if (shopInfo.value.pay_channel == null) {
                return {}
            }
            const curChannelType = shopInfo.value.online_payment - 1
            return shopInfo.value.pay_channel.find(channel => {
                return curChannelType === channel.channel_type
            }) || {}
        })

        // 组件的入口
        onBeforeMount(() => {
            getShopInfo()
        })

        // 获取店铺信息
        const getShopInfo = () => {
            isLoading.value = true
            return $fetch.post({
                url: '/shop/getshopinfo'
            }).then(data => {
                console.log('店铺信息', clone(data))
                ctx.root.$store.commit('shop/setShopInfo', data)
                shopInfo.value = JSON.parse(JSON.stringify(data))
                if (shopInfo.value.pay_channel.status == null) {
                    ctx.root.$set(shopInfo.value.pay_channel, 'status', -1)
                }
                // shopInfo.value.pay_channel 取最后一个
                shopInfo.value.pay_channel = shopInfo.value.pay_channel
                logo.value = getQiniuImgUrl(data.logo_image_url, 800)
                cascaderValue.value = [
                    data.province_code,
                    data.city_code,
                    data.district_code
                ].filter(el => el != null)
                .map(el => el.toString())
                addressValue.value = data.detailed_address
                propAddressOne.value = {
                    pCode: data.province_code,
                    cCode: data.city_code,
                    dCode: data.district_code,
                    address: data.detailed_address
                }
                propAddressTwo.value = {
                    pCode: data.province_code,
                    cCode: data.city_code,
                    dCode: data.district_code,
                    address: data.detailed_address
                }
            })
            .catch(e => openMessage('error', e.message || '获取店铺信息失败'))
            .finally(() => isLoading.value = false)
        }
        const updateImg = (key, value) => {
             $fetch.post({
                url: '/shop/editshopinfo',
                params: {
                    [key]: value
                }
            }).then(data => {
                openMessage('success', '修改成功')
                getShopInfo()
            }, e => openMessage('error', e.message || '修改失败'))
        }
        const uploadLicenseSuccess = ({
            imgSrc,
            key
        }) => {
            bussiness_license_url.value = imgSrc
            updateImg('bussiness_license_url', key)
        }
        const uploadPermissionSuccess = ({
            imgSrc,
            key
        }) => {
            bussiness_permission_url.value = imgSrc
            updateImg('bussiness_permission_url', key)
        }
        const uploadSuccess = ({
            imgSrc,
            key
        }) => {
            logo.value = imgSrc
            updateImg('logo_image_url', key)
        }
        // 修改店铺名
        const updateShopName = () => {
            ctx.refs.updateShopName.open({
                name: shopInfo.value.shop_name
            })
        }
        const updateShowStatus = (val) => {
            $fetch.post({
                url: '/shop/editshopinfo',
                params: {
                    show_bussiness: val
                }
            }).then(data => {
                openMessage('success', '修改成功')
            }, e => openMessage('error', e.message || '修改失败'))
            .then(() => getShopInfo())
        }
        const updateDes = () => {
            if(shopInfo.value.auth_status !== 1) {
                return openMessage('error', '请先完成店铺认证')
            }
            ctx.refs.updateDes.open({
                name: shopInfo.value.description
            })
        }
        // 修改手机号
        const updatePhone = () => {
            ctx.refs.updatePhone.open({
                phone: shopInfo.value.creator && shopInfo.value.creator.phone
            })
        }
        // 修改地址
        const saveAddress = () => {
            $fetch.post({
                url: '/shop/editshopinfo',
                params: {
                    district_code: +cascaderValue.value[2] || -1,
                    detailed_address: addressValue.value
                }
            }).then(data => {
                openMessage('success', '修改成功')
                getShopInfo()
            }, e => {
                openMessage('error', e.message || '修改失败')
                setTimeout(() => {
                    ctx.refs.mapChooseTwo.updateCenter(propAddressOne.value)
                }, 100)
            })
            .finally(() => isEditAddress.value = false)
        }
        const getDetail = (addressDetail) => {
            console.log(addressDetail)
            cascaderValue.value = addressDetail.p_c_d_code
            addressValue.value = addressDetail.address
        }
        const updateAddress = () => {
            isEditAddress.value = true
            setTimeout(() => {
                ctx.refs.mapChooseOne.updateCenter(propAddressOne.value)
            }, 100)
        }
        const cascaderChange = (newVal) => {
            const arr = ['pCode', 'cCode', 'dCode']
            newVal.forEach((item, index) => {
                propAddressOne.value[arr[index]] = item
            })
        }
        const handleAddressBlur = () => {
            if (propAddressOne.value.address !== addressValue.value) {
                propAddressOne.value.address = addressValue.value
            }
        }
        // 店铺认证
        const toAuthenticate = (status) => {
            console.log('toAuthenticate status: ', status)
            if (shopInfo.value.shop_type === 1) { // 连锁直营店
                return // 暂时不前往认证
            }
            let params,
                path
            if (status === -1) { // 未认证
                params = {
                    shop_id: shopInfo.value.id,
                    shop_type: 'new_ls',
                    shop_name: shopInfo.value.shop_name,
                    shop_super_admin_passport_id: shopInfo.value.creator && shopInfo.value.creator.passport_id
                }
                path = '#/main/shopApply'
            } else {
                params = {
                    shop_id: shopInfo.value.id,
                    shop_type: 'new_ls'
                }
                path = '#/main/shopApplyStatus'
            }
            const result = CENTER_DOMAIN + path + queryify(params)
            window.location.href = result
        }
        // 支付申请
        const payToApply = () => {
            if (shopInfo.value.shop_type === 1) { // 连锁直营店
                if (shopInfo.value.chain_shop !== null && shopInfo.value.chain_shop.online_payment === 0) {
                    return openMessage("warning", "直营店统一入账到连锁总部账户，请联系总部开通")
                }
            }
            if (shopInfo.value.pay_channel == null) { return }
            // 如果时间建行支付，无需店铺认证，直接申请建行渠道
            if (shopInfo.value.chain_shop !== null ) {
                return toCenter('申请或选择支付通道')
            }
            console.log('当前支付通道信息', getCurChannel.value)
            if (shopInfo.value.auth_status !== 1) { // 未认证 认证中 已拒绝
                const obj = {
                    '-1': {
                        confirmBtn: '去认证',
                        msg: '已认证店铺才可申请开通在线支付，您的店铺暂未认证，请前往认证。'
                    },
                    '0': {
                        confirmBtn: '确认',
                        msg: '已认证店铺才可申请开通在线支付，店铺认证尚在审核中。'
                    },
                    '2': {
                        confirmBtn: '去认证',
                        msg: '已认证店铺才可申请开通在线支付，店铺尚未认证，请重新进行认证。'
                    }
                }
                if (!obj[shopInfo.value.auth_status]) {
                    return
                }
                // 弹窗 去认证
                openWarning({
                    title: '认证提示',
                    type: 'primary',
                    render(h) {
                        return (
                            <p style="width: 256px; line-height: 24px; margin: 0 auto; text-align: center; font-size: 16px; font-weight: 500;">{ obj[shopInfo.value.auth_status].msg }</p>
                        )
                    },
                    confirmBtnText: obj[shopInfo.value.auth_status].confirmBtn,
                    cancelBtnText: '取消'
                }).then(() => {
                    if (shopInfo.value.auth_status !== 0) {
                        toAuthenticate(shopInfo.value.auth_status)
                    }
                }, () => {
                    console.log('cancel')
                })
            } else {
                if (shopInfo.value.online_payment === 0) {
                    if (shopInfo.value.pay_channel.length === 0) {
                        toCenter('申请或选择支付通道')
                    } else {
                        if (shopInfo.value.pay_channel[0].status === -1 || shopInfo.value.pay_channel[0].status === 1) {
                            toCenter('申请或选择支付通道')
                        }
                        if (shopInfo.value.pay_channel[0].status === 0 || shopInfo.value.pay_channel[0].status === 2) {
                            toCenter('查看支付通道申请状态')
                        }
                    }
                } else {
                    // if (getCurChannel.value.status === 1 && getCurChannel.value.channel_type === 1) {
                    //     toCenter('更换支付通道')
                    // } 
                    toCenter('更换支付通道')
                }
            }
        }

        // 支付申请的文案提示
        const payText = () => {
            const payChannel = shopInfo.value.pay_channel.slice(-1)
            if (payChannel[0].channel_type  === 0) {  // 表示扫呗渠道
                if(payChannel[0].status === 0 ) {
                    return '扫呗渠道(审核中)'
                }
                if (payChannel[0].status === 1) {
                    return '扫呗通道(已开通)'
                }
                if(payChannel[0].status === 2) {
                    return '扫呗渠道(已拒绝)'
                }
            }

            if (payChannel[0].channel_type  === 1) {  // 表示商米渠道
                if(payChannel[0].status === 0 ) {
                    return '商米渠道(审核中)'
                }
                if (payChannel[0].status === 1) {
                    return  '商米通道(已开通)'
                }
                if(payChannel[0].status === 2) {
                    return '商米渠道(已拒绝)'
                }
            }

            if (payChannel[0].channel_type  === 2) { // 表示收钱吧渠道
                if(payChannel[0].status === 0 ) {
                    return '收钱吧渠道(审核中)'
                }
                if (payChannel[0].status === 1) {
                    return '收钱吧通道(已开通)'
                }
                if(payChannel[0].status === 2) {
                    return '收钱吧渠道(已拒绝)'
                }
            }

            
        }


        // 
        const payTextTip = () => {
            const payChannel = shopInfo.value.pay_channel
            const onlinePayment = shopInfo.value.online_payment - 1 // 0 扫呗 1 .商米 2 收钱ba 3 
            if (onlinePayment === 0 ) { // 扫呗
                let obj = payChannel.find(item => {
                    return item.channel_type == 0 
                })

                if(obj.status === 0 ) {
                    return '扫呗渠道(审核中)'
                }
                if (obj.status === 1) {
                    return '扫呗通道(已开通)'
                }
                if(obj.status === 2) {
                    return '扫呗渠道(已拒绝)'
                }
            }

            if (onlinePayment === 1) { // 商米渠道
                 let obj = payChannel.find(item => {
                    return item.channel_type == 1
                })

                 if(obj.status === 0 ) {
                    return '商米渠道(审核中)'
                }
                if (obj.status === 1) {
                    return  '商米通道(已开通)'
                }
                if(obj.status === 2) {
                    return '商米渠道(已拒绝)'
                }
            }

            if (onlinePayment === 2) { // 表示收钱吧渠道
                 let obj = payChannel.find(item => {
                    return item.channel_type == 2
                })

                if(obj.status === 0 ) {
                    return '收钱吧渠道(审核中)'
                }
                if (obj.status === 1) {
                    return '收钱吧通道(已开通)'
                }
                if(obj.status === 2) {
                    return '收钱吧渠道(已拒绝)'
                }
            }

            if (onlinePayment === 3) { // 表示建行渠道
                console.log('------', onlinePayment)
                let obj = payChannel.find(item => {
                    return item.channel_type == 3  // 
                })

                if(obj.status === 0 ) {
                    return '建行支付(审核中)'
                }
                if (obj.status === 1) {
                    return '建行支付(已开通)'
                }
                if(obj.status === 2) {
                    return '建行支付(已拒绝)'
                }
            }
        }

        const toCenter = type => {
            let params,
                path
            switch (type) {
                case '申请或选择支付通道':
                    params = {
                        shop_id: shopInfo.value.id,
                        shop_type: 'new_ls',
                        shop_name: shopInfo.value.shop_name,
                        shop_super_admin_passport_id: shopInfo.value.creator && shopInfo.value.creator.passport_id,
                        is_sunmi: shopInfo.value.from_sunmi ? 1 : 0,
                        is_chain: shopInfo.value.chain_shop === null ? 0 : 1, // 0 表示不是连锁店铺， 1 表示是连锁店
                    }
                    path = '#/main/paymentApprovedLoading'
                    break
                case '更换支付通道':
                    params = {
                        shop_id: shopInfo.value.id,
                        shop_type: 'new_ls',
                        paymentType: 'change',
                        shop_name: shopInfo.value.shop_name,
                        shop_super_admin_passport_id: shopInfo.value.creator && shopInfo.value.creator.passport_id,
                        is_sunmi: shopInfo.value.from_sunmi ? 1 : 0,
                        is_chain: shopInfo.value.chain_shop === null ? 0 : 1, // 0 表示不是连锁店铺， 1 表示是连锁店
                    }
                    path = '#/main/paymentApprovedLoading'
                    break
                case '查看支付通道申请状态':
                    // params = {
                    //     shop_id: shopInfo.value.id,
                    //     lc_merchant_no: shopInfo.value.pay_channel[0].merchant_no,
                    //     shop_type: 'new_ls'
                    // }
                    // path = '#/main/paymentStatus'
                    params = {
                        shop_id: shopInfo.value.id,
                        shop_type: 'new_ls',
                        paymentType: 'change',
                        shop_name: shopInfo.value.shop_name,
                        shop_super_admin_passport_id: shopInfo.value.creator && shopInfo.value.creator.passport_id,
                        is_sunmi: shopInfo.value.from_sunmi ? 1 : 0,
                        is_chain: shopInfo.value.chain_shop === null ? 0 : 1, // 0 表示不是连锁店铺， 1 表示是连锁店
                    }
                    path = '#/main/paymentApprovedLoading'
                    break
                default:
                    break
            }
            if (params == null || path == null) {
                return
            }
            const result = CENTER_DOMAIN + path + queryify(params)
            window.location.href = result
        }

        // queryify
        const queryify = (params) => {
            const arr: string[] = []
            Object.entries(params).forEach(([k, v]) => {
                if (v != null) {
                    // null和undefined会被忽略
                    arr.push(`${k}=${v}`)
                }
            })
            return `?${arr.join('&')}`
        }

        function toPayCenter() {
            const payCenterDomain = domain.center + '#/main/recordViews'
            const queryParams = queryString({
                shop_name: state.shop.shopInfo.shop_name,
                shop_id: state.shop.shopInfo.id,
                shop_type: 'new_ls',
                shop_super_admin_passport_id: shopInfo.value.creator && shopInfo.value.creator.passport_id
            }, true)
            window.location.href = payCenterDomain + queryParams
        }

        // 续费
        // function toRenew() {
        //     openNewRenew()
        // }

        return {
            // not reactive data
            options: SG_AREA,
            // data
            isLoading,
            bussiness_license_url,
            bussiness_permission_url,
            shopInfo,
            logo,
            shopDefaultLogo,
            propAddressOne,
            propAddressTwo,
            isEditAddress,
            cascaderValue,
            addressValue,
            cityName,
            updateShowStatus,
            // computed
            getShopAddress,
            getPayBtnText,
            getAuthBtnText,
            getCurChannel,
            downloadHref,
            // methods
            getShopInfo,
            uploadSuccess,
            uploadPermissionSuccess,
            uploadLicenseSuccess,
            updateShopName,
            updateDes,
            updatePhone,
            updateAddress,
            toAuthenticate,
            saveAddress,
            getDetail,
            cascaderChange,
            handleAddressBlur,
            payToApply,
            // toRenew,
            toCenter,
            toPayCenter,
            payText,
            payTextTip,
            imgSuffix
        }
    },

    components: {
        QiniuUpload,
        BaseBlock,
        UpdatePhone,
        UpdateShopName,
        UpdateDes,
        MapChoose,
        ShopRenewDownload
    }
}
</script>

<style lang="scss" scoped>
.fx-v-center {
    display: flex;
    align-items: center;
}

.des-on {
    width: 600px;
    color: #999;
    font-size: 14px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

.ml1 {
    margin-left: 10px;
}

.mb1 {
    margin-bottom: 10px;
}

.save-btn {
    min-width: 80px;
}

.weirenzheng,
.weikaitong {
    color: #e51c23;
}

.weikaitong-next {
    color: #999;
    margin-left: 8px;
}

.shenheing {
    color: #009688;

    i {
        font-size: 20px;
        margin-right: 4px;
    }

    span {
        flex: none;
    }
}

.has-refuse {
    color: #ee5b5b;
}

.renzhengpass {
    .enterprise {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 64px;
        height: 24px;
        margin-right: 4px;
        color: #FAAD14;
        background: rgba(250, 173, 20, .2);
    }
}

.shop-info {
    height: auto;
    margin-top: 12px;
    background: #FFFFFF;
    border: 1px solid #ebebeb;
    overflow-x: auto;

    .edit-address {
        
        &-top {
            > ::v-deep .el-cascader {
                width: 298px;
            }

            > ::v-deep .el-input {
                width: 428px;
            }
        }
    }

    .address-wrap {
        align-items: flex-start;
        padding: 24px 10px;

        ::v-deep .left {
            align-items: flex-start;

            &-inner {
                margin-top: 12px;
            }
        }
    }

    .set-top-line {
        position: relative;

        &::before {
            content: '';
            position: absolute;
            left: 10px;
            right: 10px;
            top: -0.5px;
            height: 1px;
            background-color: #ebebeb;
        }
    }

    .set-bottom-line {
        position: relative;

        &::before {
            content: '';
            position: absolute;
            left: 10px;
            right: 10px;
            bottom: -0.5px;
            height: 1px;
            background-color: #ebebeb;
        }
    }

    .shop-logo {
        width: 60px;
        height: 60px;
        border: 1px solid rgba(0,0,0,0.10);
        border-radius: 3px;
        cursor: pointer;
    }

    .renzheng {

        ::v-deep .des {
            color: #E51C23;
        }
    }

    .shenheing {
        width: 20px;
        height: 20px;
        margin-right: 4px;

        & + span {
            color: #009688;
        }
    }

    .authenticated {

        .enterprise {
            display: inline-flex;
            justify-content: center;
            align-items: center;
            width: 64px;
            height: 24px;
            margin-right: 4px;
            color: #FAAD14;
            background: rgba(250, 173, 20, .2);
        }
    }

    .refuse {
        color: #ee5b5b;
    }

    .wx-info {
        flex: 1;

        .person-logo {
            display: inline-block;
            width: 32px;
            height: 16px;
            line-height: 16px;
            margin-left: 4px;
            text-align: center;
            font-size: 12px;
            color: #FAAD14;
            background: #FFFFFF;
            border: 1px solid #FAAD14;
            border-radius: 3px;
        }

        ::v-deep .realname {
            color: #333;
        }
    }
}

.service-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 12px;
    color: #333;
    overflow: hidden;

    &-left {
        flex: 1;
        height: 60px;
        line-height: 60px;
        padding-left: 12px;
        font-size: 14px;

        &-name-wrapper {
            img {
                width: 20px;
                height: 20px;
                margin-right: 4px;
            }

            span {
                display: inline-block;
                min-width: 56px;
                margin-right: 20px;
                font-weight: 600;
            }
        }
    }

    &-right {
        height: 60px;
        line-height: 60px;
        padding-right: 12px;
        text-align: right;
        z-index: 3;

        .btn {
            width: 120px;
            height: 36px;
            line-height: 36px;
            padding: 0;
            border-width: 0;
            border-radius: 4px;
            text-align: center;
            outline: none;
            color: #fff;
            font-size: 16px;
            font-weight: 600;
            cursor: pointer;

            &:active {
                transform: scale(.9);
            }
        }
    }

    &.pay {
        background: linear-gradient(-45deg, #feefd3, #fce6bf calc(100% - 220px), #feefd3 0, #feefd3);

        .service-wrapper-right .btn {
            background: linear-gradient(to right, #BE8A0C, #E19F00);
        }
    }

    &.download {
        background: linear-gradient(-45deg, #EAFCF8, #D5F8F3 calc(100% - 220px), #EAFCF8 0, #EAFCF8);

        .service-wrapper-right .btn {
            background: #009688;
        }
    }
}
</style>
